import type { Pill } from "../../../model/invoice-view";
import type { TicketKategorie, TicketStatus } from "./data";

/** Beschriftungen für Hilfe & Support (0176), rein und testbar */
export function ticketStatusPill(s: string, t: (de: string, en: string) => string): Pill {
  switch (s as TicketStatus) {
    case "offen": return { label: t("Offen", "Open"), tone: "info", symbol: "●" };
    case "in_bearbeitung": return { label: t("In Bearbeitung", "In progress"), tone: "info", symbol: "◐" };
    case "wartet_auf_kunde": return { label: t("Antwort von uns", "Reply from us"), tone: "warning", symbol: "!" };
    case "geloest": return { label: t("Gelöst", "Solved"), tone: "success", symbol: "✓" };
    case "geschlossen": return { label: t("Geschlossen", "Closed"), tone: "neutral", symbol: "○" };
    default: return { label: s, tone: "neutral", symbol: "○" };
  }
}
export function kategorieLabel(k: string, t: (de: string, en: string) => string): string {
  switch (k as TicketKategorie) {
    case "fehler": return t("Fehler", "Bug");
    case "frage": return t("Frage", "Question");
    case "abrechnung": return t("Abrechnung", "Billing");
    case "wunsch": return t("Wunsch", "Feature request");
    case "einrichtung": return t("Einrichtung", "Setup");
    default: return k;
  }
}
export function meldungStatusPill(s: string, t: (de: string, en: string) => string): Pill {
  switch (s) {
    case "neu": return { label: t("Eingegangen", "Received"), tone: "info", symbol: "●" };
    case "in_arbeit": return { label: t("Wird bearbeitet", "Being worked on"), tone: "info", symbol: "◐" };
    case "erledigt": return { label: t("Behoben", "Fixed"), tone: "success", symbol: "✓" };
    case "kein_fehler": return { label: t("Kein Fehler", "Not a bug"), tone: "neutral", symbol: "○" };
    default: return { label: s, tone: "neutral", symbol: "○" };
  }
}
export function ticketNummer(n: number): string {
  return `#${n}`;
}
/** Dateigröße kurz („1,2 MB“, „350 KB“) */
export function groesse(bytes: number | null | undefined, locale = "de-DE"): string {
  if (!bytes || bytes < 0) return "";
  if (bytes >= 1024 * 1024) return `${new Intl.NumberFormat(locale, { maximumFractionDigits: 1 }).format(bytes / 1024 / 1024)} MB`;
  return `${Math.max(1, Math.round(bytes / 1024))} KB`;
}
